



















































































































































/** @format */
import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import OrganizationSearch from '@/components/organization-search/index.vue';
import Utils from '@root/utils/common';
import { post, download } from '@root/utils/httpWrap';
import moment from 'moment';
import {
  getRuleMonitoringEvent,
  queryserchRuleMonitoring,
  applyParkByMonitorId,
  applyJobByMonitorId,
  querychangeStatus,
  deleteStatus
} from '@/api/monitor-alarm-center/index';
import { RULE_MANAGEMENT_CREATE, RULE_MANAGEMENT_EDIT, RULE_MANAGEMENT_DETAIL } from '../router-names';
import lodash from 'lodash';
@Component({
  name: 'RuleManagement',
  components: { OrganizationSearch }
})
export default class RuleManagement extends Mixins(TableMixin, TableWidthMixin) {
  private filterParam: any = {
    monitorEvent: undefined, // 监控类型/事件
    startCreateTime: '', // 创建日期开始
    endCreateTime: '', // 创建日期结束
    status: '', // 状态
    organId: ''
  };

  // 状态
  statusOptions: any[] = [{ value: '01', label: '已启用' }, { value: '00', label: '已停用' }];

  eventsOption: any[] = []; // 监控类型/事件

  private moment = moment;
  // 默认创建日期
  get defaultTime() {
    if (this.filterParam.startCreateTime && this.filterParam.endCreateTime) {
      return [
        this.moment(this.filterParam.startCreateTime, 'YYYY-MM-DD'),
        this.moment(this.filterParam.endCreateTime, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.startCreateTime) {
      return [this.moment(this.filterParam.startCreateTime, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  // 创建日期禁用规则
  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }
  // 选择创建日期
  private onTimeChange(date: any, dateString: any) {
    let [operateTimeStart, operateTimeEnd] = dateString;
    this.filterParam.startCreateTime = operateTimeStart;
    this.filterParam.endCreateTime = operateTimeEnd;
  }

  tableLoading: boolean = false;
  tableData: any[] = []; // 表格数据
  // 表头数据
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '所属机构',
        dataIndex: 'organName',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '监控类型/事件',
        dataIndex: 'ruleType',
        width: 240,
        scopedSlots: { customRender: 'rule-type' }
      },
      {
        title: '配置规则',
        dataIndex: 'rulesDetail',
        width: 240,
        scopedSlots: { customRender: 'rules-detail' }
      },
      {
        title: '适用车场',
        dataIndex: 'parkNum',
        width: 140,
        scopedSlots: { customRender: 'park-num' }
      },
      {
        title: '推送岗位组',
        dataIndex: 'positionNum',
        width: 140,
        scopedSlots: { customRender: 'position-num' }
      },
      {
        title: '推送方式',
        dataIndex: 'pushMode',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        width: 200
      },
      {
        title: '创建人',
        dataIndex: 'createBy',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 260,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  parkingLotVisible: boolean = false; // 适用车场范围
  parkingLotList: any[] = []; // 适用车场数据
  // 显示适用车场
  showParkingLot(monitorId: string) {
    this.parkingLotVisible = true;
    this.fetchParkingLotData(monitorId);
  }
  // 关闭适用车场
  closeParkingLot() {
    this.parkingLotVisible = false;
  }
  // 获取适用车场范围
  async fetchParkingLotData(monitorId: string) {
    try {
      const result = await applyParkByMonitorId({ monitorId });
      this.parkingLotList = result.data;
    } catch (e) {
      this.$message.error('获取适用车场范围失败');
    }
  }

  jobGroupVisible: boolean = false; // 推送岗位组
  jobGroupList: any[] = []; // 推送岗位组数据
  // 显示推送岗位组
  showJobGroup(monitorId: string) {
    this.jobGroupVisible = true;
    this.fetchJobGroupData(monitorId);
  }
  // 关闭推送岗位组
  closeJobGroup() {
    this.jobGroupVisible = false;
  }
  // 获取推送岗位组
  async fetchJobGroupData(monitorId: string) {
    try {
      const result = await applyJobByMonitorId({ monitorId });
      this.jobGroupList = result.data;
    } catch (e) {
      this.$message.error('获取推送岗位组失败');
    }
  }

  // 启用停用状态切换
  async toggleMonitorRuleStatus(monitorId: string) {
    try {
      await querychangeStatus({ monitorId });
      this.fetchTableData();
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }

  // 删除
  async toDelete(monitorId: string) {
    try {
      await deleteStatus({ monitorId });
      this.fetchTableData();
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }

  //新增
  editItem(name, row) {
    if (name == 'add') {
      this.$router.push({
        name: RULE_MANAGEMENT_CREATE
      });
    } else if (name == 'edit') {
      this.$router.push({
        name: RULE_MANAGEMENT_EDIT,
        params: {
          id: row.monitorId
        }
      });
    } else {
      this.$router.push({
        name: RULE_MANAGEMENT_DETAIL,
        params: {
          id: row.monitorId
        },
        query: row
      });
    }
  }

  // 获取监控类型/事件
  async fetchMonitoringEvent() {
    try {
      // @ts-ignore
      const result = await getRuleMonitoringEvent();
      const data = result.data;
      data.forEach(row => {
        row.value = Math.random();
      });
      this.eventsOption = data;
    } catch (e) {
      this.$message.error('获取监控事件失败');
    }
  }

  current = 1;
  pageSize = 10;

  // 获取表格数据
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    let d = lodash.cloneDeep(this.filterParam),
      eventsChild = (this.eventsOption.find(item => item.value == d.monitorEvent) || {}).children || null;
    if (eventsChild) {
      d.monitorEvent = eventsChild.map(item => item.value).join(',');
    }
    try {
      const res = await queryserchRuleMonitoring({
        ...d,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { data } = res;
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = data.datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  //搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空
  onTableFilterClear() {
    this.filterParam = lodash.cloneDeep(this.copiedFilterParam);
    this.searchTable();
  }

  copiedFilterParam = null;

  created() {
    this.copiedFilterParam = lodash.mergeWith({}, this.filterParam);
    this.fetchMonitoringEvent();
    this.fetchTableData();
  }
}
